import React, { useState, useEffect } from 'react';

// Replace with the URL of your API endpoint that returns the visitor stats
const API_URL = 'https://your-backend-api.com/visitor-stats';

const VisitorsCount = () => {
  const [visitorStats, setVisitorStats] = useState({
    totalVisitors: 0,
    visitorsToday: 0,
    visitorsYesterday: 0,
    visitorsLastMonth: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch visitor statistics from the backend API
  useEffect(() => {
    const fetchVisitorStats = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) {
          throw new Error('Failed to fetch visitor stats');
        }
        const data = await response.json();
        setVisitorStats({
          totalVisitors: data.totalVisitors,
          visitorsToday: data.visitorsToday,
          visitorsYesterday: data.visitorsYesterday,
          visitorsLastMonth: data.visitorsLastMonth,
        });
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVisitorStats();
  }, []);

  // Styles
  const containerStyle = {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f9f9f9',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    width: '300px',
    margin: '0 auto',
  };

  const headerStyle = {
    textAlign: 'center',
    color: '#333',
  };

  const listStyle = {
    listStyleType: 'none',
    padding: '0',
  };

  const listItemStyle = {
    padding: '8px 0',
    color: '#666',
    fontSize: '14px',
    borderBottom: '1px solid #ddd',
  };

  const lastListItemStyle = {
    ...listItemStyle,
    borderBottom: 'none',
  };

  const loadingStyle = {
    textAlign: 'center',
    color: '#888',
  };

  const errorStyle = {
    color: 'red',
  };

  // Display loading or error message
  if (loading) {
    return <div style={loadingStyle}>Loading visitor stats...</div>;
  }

  if (error) {
    return <div style={errorStyle}>Error: {error}</div>;
  }

  return (
    <div style={containerStyle}>
      <h3 style={headerStyle}>Visitor Statistics</h3>
      <ul style={listStyle}>
        <li style={listItemStyle}>Total Visitors: {visitorStats.totalVisitors}</li>
        <li style={listItemStyle}>Visitors Today: {visitorStats.visitorsToday}</li>
        <li style={listItemStyle}>Visitors Yesterday: {visitorStats.visitorsYesterday}</li>
        <li style={lastListItemStyle}>Visitors Last Month: {visitorStats.visitorsLastMonth}</li>
      </ul>
    </div>
  );
};

export default VisitorsCount;

